module.exports = "\r\n.mt-top-19 {\r\n  margin-top: 19px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shipping-components/add-shipping-cost/add-shipping-cost.component.css
// module id = ./src/app/shipping-components/add-shipping-cost/add-shipping-cost.component.css
// module chunks = main